<template>
    <div class="container">
        <back-button location="/technologies"></back-button>

        <h1 class="title">C# .Net</h1>
        <div class="logo swing-animation">
            <img src="../../assets/images/C_Sharp.svg"/>
        </div>
        <div class="content">
            <div class="dotnet-version-chart">
                <p class="fun-fact">69% of C# projects make use of WebAPI for loosely coupled web services</p>
                <div class="chart-group">
                    <p class="chart-sub-title">C# version usage for Entelectuals on their main projects</p>
                    <apex-charts type="donut" :options="versionOptions" :series="versionSeries"
                                 class="chart"></apex-charts>
                </div>
            </div>
            <div class="dotnet-module-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Runtime frameworks used by Entelectuals</p>
                    <apex-charts type="bar" :options="moduleOptions" :series="moduleSeries" class="chart"></apex-charts>
                </div>
                <p class="fun-fact">16% of .NET applications run as microservices and 53% run as web applications</p>
            </div>
            <div class="dotnet-serve-chart">
                <p class="fun-fact">WebAPI, Entity Framework, ASP.NET MVC, and ASP.NET Core, and LINQ to SQL are the
                    most used C# frameworks</p>
            </div>
            <div class="dotnet-build-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">More than half of .NET applications are run as a Web App</p>
                    <apex-charts type="bar" :options="serveOptions" :series="serveSeries" class="chart"
                                 height="250"></apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueApexCharts from "vue-apexcharts/src";
    import BackButton from "../../widgets/BackButton";

    export default {
        components: {
            'apex-charts': VueApexCharts,
            BackButton
        },
        data: function () {
            return {
                versionOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    legend: {
                        labels: {
                            color: '#FFF'
                        },
                        position: 'bottom',
                    },
                    colors: ['#F7941D', '#008AD0', '#B51E8E', '#00994C'],
                    labels: ['C# 7', 'C# 6', 'C# 5', 'Below C# 5'],
                    tooltip: {
                        enabled: true,
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                    stroke: {
                        width: 0
                    },
                    fill: {
                        patern: {
                            width: 500
                        }
                    },
                    dataLabels: {
                        formatter: function (val, opt) {
                            if (val < 10)
                                return `${Math.round(val)}%`;

                            return `${opt.w.globals.labels[opt.seriesIndex]}: ${Math.round(val)}%`;
                        },
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%',
                            },
                        }
                    },
                    responsive: [{
                        breakpoint: 599,
                        options: {
                            dataLabels: {
                                formatter: function (val) {
                                    if (val < 5)
                                        return '';
                                    return `${Math.round(val)}%`;
                                },
                            },
                        }
                    }]
                },
                versionSeries: [43.6, 39.7, 10.3, 6.4],
                moduleOptions: {
                    chart: {
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            if (val < 5) {
                                return '';
                            }

                            return `${Math.round(val)}%`;
                        }
                    },
                    colors: ['#F7941D', '#009EA5', '#B51E8E', '#00994C', '#008AD0'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    legend: {
                        position: 'top',
                        labels: {
                            color: '#FFF'
                        }
                    },
                    yaxis: {
                        show: false,
                        labels: {
                            show: false,
                            style: {
                                color: '#FFF',
                            },
                        },
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        },
                        categories: ['Runtime'],
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                },
                moduleSeries: [{
                    name: '.Net Core',
                    data: [43.6]
                }, {
                    name: 'Mono',
                    data: [2.6]
                }, {
                    name: '.Net Framework',
                    data: [89.1]
                }],
                serveOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#B51E8E', '#009EA5', '#F7941D', '#008AD0', '#00994C'],
                    labels: ['Web App', 'Cloud App', 'Microservice', 'Web Site', 'Windows Service'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                        }
                    },
                    xaxis: {
                        categories: ['Web App', 'Cloud App', 'Microservice', 'Web Site', 'Windows Service', 'Serverless'],
                        labels: {
                            style: {
                                colors: ['#B51E8E', '#009EA5', '#F7941D', '#008AD0', '#00994C', '#B51E8E'],
                                fontSize: '14px'
                            }
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        },
                        marker: {
                            show: true
                        }
                    },
                },
                serveSeries: [{
                    name: 'Amount',
                    data: [53.8, 10.3, 16, 10.9, 7.1, 1.9]
                }],
            }
        },
        methods: {
            track() {
                this.$ga.page('/2018/technology/dotnet') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 600px 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: 'back title   logo' 'content content content';
        color: white;
        text-align: center;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .logo {
            grid-area: logo;
            height: 160px;
            width: 160px;
            align-self: start;
            justify-self: end;
            background: $green;
            border-bottom-left-radius: 100%;
            display: grid;

            @media only screen and (max-width: $screen-xs-max) {
                display: none;
            }

            img {
                width: 50%;
                height: 50%;
                align-self: start;
                justify-self: end;
                margin: 20px;
            }
        }

        .title {
            grid-area: title;
            align-self: center;
            justify-self: center;
            align-content: center;
            justify-content: center;
            margin: 24px;
            display: grid;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. version module .' '. serve build .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto auto;

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-areas: '. version .' '. module .' '. serve .' '. build .';
                grid-template-columns: 1fr 2fr 1fr;
            }

            .fun-fact {
                align-self: center;
                justify-self: center;
                margin: 24px;
            }

            .chart {
                width: 360px;
                align-self: center;
                justify-self: center;

                @media only screen and (max-width: $screen-xs-max) {
                    width: 250px;
                }
            }

            .chart-group {
                border-left: 2px solid $entelect-orange;
                padding-left: 24px;
                margin-bottom: 16px;
                display: grid;
            }

            .chart-title {
                align-self: start;
                justify-self: start;
            }

            .chart-sub-title {
                align-self: start;
                justify-self: start;
                text-align: left;
                margin-bottom: 24px;
            }

            .dotnet-version-chart {
                grid-area: version;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .dotnet-serve-chart {
                grid-area: serve;
                display: grid;
                padding-top: 24px;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .dotnet-module-chart {
                grid-area: module;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .dotnet-build-chart {
                grid-area: build;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                    margin: 0;
                }
            }
        }
    }
</style>
